jQuery(document).ready(function ($) {

    $(document).on('click', '.filter-toggle', function () {
        $('.filter-drawer').addClass('active');
        $('.filter-overlay').addClass('active');
        $('body').addClass('drawer-open');
    });

    $(document).on('click', '.drawer-close, .filter-overlay', function () {
        $('.filter-drawer').removeClass('active');
        $('.filter-overlay').removeClass('active');
        $('body').removeClass('drawer-open');
    });

    $(document).on('click', '.filter-title', function () {
        $(this).toggleClass('active');
        $(this).next('.filter-content').stop().slideToggle();
    });

});


// ajax code //

$(function () {

    let priceFilterTouched = false;

    function getPriceParamNames() {
        return {
            min: $('#shopify-min-price').attr('name'),
            max: $('#shopify-max-price').attr('name')
        };
    }

    // Treat price as "active" only if the current URL actually
    // carries the price params (i.e. it was deliberately submitted
    // or the page was loaded/shared with a price filter applied).
    function syncPriceTouchedFromURL() {

        let names = getPriceParamNames();

        if (!names.min || !names.max) {
            priceFilterTouched = false;
            return;
        }

        let params = new URLSearchParams(window.location.search);

        priceFilterTouched = params.has(names.min) || params.has(names.max);

    }

    syncPriceTouchedFromURL();

    function updateCollection(url, updateHistory = true) {

        const $container = $('#CollectionContainer');

        $container.addClass('loading');

        $.get(url, function (response) {

            var html = $(response);

            $container.html(
                html.find('#CollectionContainer').html()
            );

            if (updateHistory) {
                history.pushState({}, '', url);
            }

            // Close drawer
            $('.filter-drawer').removeClass('active');
            $('.filter-overlay').removeClass('active');
            $('body').removeClass('drawer-open');

            // Scroll to top of products
            $('html, body').animate({
                scrollTop: $('#CollectionContainer').offset().top - 30
            }, 400);

            // Re-init price slider visuals for newly injected DOM
            updateSlider();

            // Re-apply saved grid/list view to the newly injected grid
            applyGridView();

            // Keep price-active state in sync with the new URL
            syncPriceTouchedFromURL();

        }).always(function () {

            // Remove loading state
            $('#CollectionContainer').removeClass('loading');

            // Safety: remove overlay if it gets stuck
            $('.filter-overlay').removeClass('active');
            $('body').removeClass('drawer-open');

        });

    }

    $(document).on('submit', '#CollectionFiltersForm', function (e) {

        e.preventDefault(); // Stop normal form submit

        let formData = $(this).serializeArray();

        let priceNames = getPriceParamNames();

        let params = new URLSearchParams();

        $.each(formData, function (_, item) {

            // Skip the price range params if the user never touched
            // the slider — otherwise it always shows as "active"
            // since the hidden fields always carry the full range.
            if (!priceFilterTouched && (item.name === priceNames.min || item.name === priceNames.max)) {
                return;
            }

            params.append(item.name, item.value);
        });

        // Keep selected sort
        let sort = $('#SortBy').val();

        if (sort) {
            params.set('sort_by', sort);
        }

        updateCollection(
            window.location.pathname + '?' + params.toString()
        );

    });

    $(document).on('click', '.active-filter, .clear-filters', function (e) {

        e.preventDefault();

        let url = $(this).attr('href');

        updateCollection(url);

    });

    $(document).on('change', '#SortBy', function () {

        let params = new URLSearchParams(window.location.search);

        params.set('sort_by', $(this).val());

        updateCollection(
            window.location.pathname + '?' + params.toString()
        );

    });

    $(document).on('click', '.pagination-wrapper a', function (e) {

        e.preventDefault();

        let url = $(this).attr('href');

        updateCollection(url);

    });

    $(window).on('popstate', function () {

        updateCollection(window.location.href, false);

    });

    $(document).on('click', '.quick-add', function (e) {

        e.preventDefault();
        e.stopPropagation();

        let variantId = $(this).data('variant-id');

        $.ajax({
            url: '/cart/add.js',
            type: 'POST',
            dataType: 'json',
            data: {
                id: variantId,
                quantity: 1
            },
            success: function () {

                // Open your cart drawer here
                openCartDrawer();

            },
            error: function (xhr) {
                console.log(xhr.responseText);
            }
        });

    });

    // ---- Custom sort dropdown ----
    // Drives the real (hidden) #SortBy select, so the existing
    // 'change' handler above still fires the AJAX sort unchanged.

    $(document).on('click', '#SortToggle', function (e) {

        e.stopPropagation();

        let $dropdown = $('#SortDropdown');
        let isOpen = $dropdown.hasClass('open');

        $dropdown.toggleClass('open', !isOpen);
        $(this).attr('aria-expanded', !isOpen);

    });

    $(document).on('click', '.sort-option', function () {

        let value = $(this).data('value');

        $('#SortBy').val(value).trigger('change');

        $('.sort-option').removeClass('active');
        $(this).addClass('active');

        $('#SortDropdown').removeClass('open');
        $('#SortToggle').attr('aria-expanded', 'false');

    });

    // Close when clicking anywhere outside the dropdown
    $(document).on('click', function (e) {

        if (!$(e.target).closest('.sort-wrap').length) {
            $('#SortDropdown').removeClass('open');
            $('#SortToggle').attr('aria-expanded', 'false');
        }

    });

    // ---- Grid / List view toggle ----

    function applyGridView() {

        let savedView = localStorage.getItem('collectionView') || '4';

        let $grid = $('#CollectionProductGrid');

        if (!$grid.length) return;

        $grid.removeClass('view-2 view-6 view-4 view-3 view-list').addClass('view-' + savedView);

        $('.view-btn').removeClass('active');
        $('.view-btn[data-view="' + savedView + '"]').addClass('active');

    }

    $(document).on('click', '.view-btn', function () {

        let view = $(this).data('view');

        localStorage.setItem('collectionView', view);

        applyGridView();

    });

    // Initial paint on first page load
    applyGridView();

    // ---- Price range slider ----
    // NOTE: bound with delegation on document so it keeps working
    // after #CollectionContainer is replaced by AJAX.

    function updateSlider() {

        let $rangeMin = $("#range-min");
        let $rangeMax = $("#range-max");

        if (!$rangeMin.length || !$rangeMax.length) return;

        let maxRange = parseInt($rangeMax.attr("max"));

        let min = parseInt($rangeMin.val());
        let max = parseInt($rangeMax.val());

        if (min > max - 1) {
            min = max - 1;
            $rangeMin.val(min);
        }

        let percent1 = (min / maxRange) * 100;
        let percent2 = (max / maxRange) * 100;

        $(".slider-range").css({
            left: percent1 + "%",
            width: (percent2 - percent1) + "%"
        });

        $("#min-price").val(min);
        $("#max-price").val(max);

        // Shopify's price_range filter param expects the plain
        // currency amount (e.g. 100), NOT cents (e.g. 10000).
        $("#shopify-min-price").val(min);
        $("#shopify-max-price").val(max);

    }

    // Delegated events — survive the #CollectionContainer being
    // replaced wholesale by the AJAX filter/sort/pagination calls.
    $(document).on("input", "#range-min, #range-max", function () {
        priceFilterTouched = true;
        updateSlider();
    });

    $(document).on("change", "#min-price", function () {
        $("#range-min").val($(this).val());
        priceFilterTouched = true;
        updateSlider();
    });

    $(document).on("change", "#max-price", function () {
        $("#range-max").val($(this).val());
        priceFilterTouched = true;
        updateSlider();
    });

    // Initial paint on first page load
    updateSlider();

});